// src/AppRouter.jsx
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ReactKeycloakProvider, useKeycloak } from "@react-keycloak/web";

import keycloak from "./helpers/Keycloak.js";

import App from "./App";
import RegistrationForm from "./components/RegistrationForm";
import PublicServices from "./components/PublicServices.jsx";
import AnonymousChatbotPage from "./components/chatbot/AnonymousChatbotPage.jsx";

const PUBLIC_PATHS = ["/register", "/publicservices", "/zippy"];

const keycloakInitOptions = {
    onLoad: "login-required",
    checkLoginIframe: false,
    responseMode: "query",
    pkceMethod: "S256",
    redirectUri: window.location.origin + window.location.pathname,
};

function handleTokens(tokens) {
    if (tokens.token) {
        const url = new URL(window.location.href);
        url.searchParams.delete("code");
        url.searchParams.delete("state");
        url.searchParams.delete("session_state");
        url.searchParams.delete("iss");
        window.history.replaceState({}, document.title, url.pathname + url.search);
    }
}

function handleKeycloakEvent(event, error) {
    console.log(`📡 Keycloak event: ${event}`);
    if (error) console.error("⚠️ Error in event:", error);
}

function isPublicPath(pathname) {
    return PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(p + "/"));
}

export default function AppRouter() {
    const { pathname } = useLocation();

    if (isPublicPath(pathname)) {
        return (
            <Routes>
                <Route path="/zippy" element={<AnonymousChatbotPage />} />
                <Route path="/register" element={<RegistrationForm />} />
                <Route path="/publicservices" element={<PublicServices />} />
                <Route path="*" element={<AnonymousChatbotPage />} />
            </Routes>
        );
    }

    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={keycloakInitOptions}
            onTokens={handleTokens}
            onEvent={handleKeycloakEvent}
        >
            <PrivateGate />
        </ReactKeycloakProvider>
    );
}

function PrivateGate() {
    const { keycloak, initialized } = useKeycloak();

    if (!initialized) return <div>Loading Keycloak...</div>;
    if (!keycloak.authenticated) return <div>Redirecting to login...</div>;

    return <App keycloak={keycloak} />;
}